import type { LoyaltyProgramStatus } from '../../types/loyalty'

// What the programme list and the editor share: the one name limit the API
// enforces (programme and rung names alike) and the status pill.

/** `MAX_PROGRAM_NAME_LENGTH` / `MAX_TIER_NAME_LENGTH` on the API: both 100. */
export const MAX_NAME_LENGTH = 100

const STATUS_PILL: Record<LoyaltyProgramStatus, string> = {
  DRAFT: 'bg-gray-100 text-gray-700',
  PUBLISHED: 'bg-green-100 text-green-800',
  ENDED: 'border border-gray-300 bg-white text-gray-500',
}

export const StatusPill = ({ status }: { status: LoyaltyProgramStatus }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_PILL[status]}`}
  >
    {status}
  </span>
)
